import { createDataModule } from '@perpay-web/data-module/createDataModule';
import {
    fetchPartnerHostedCardApplication,
    fetchPartnerHostedCardApplicationSuccess,
    fetchPartnerHostedCardApplicationError,
    fetchPartnerHostedCardApplicationReset,
} from '@perpay-web/fintech/actions/ui/partnerHostedCardApplication';

const PartnerHostedCardApplicationDataModule = createDataModule({
    dataRequest: fetchPartnerHostedCardApplication,
    dataSuccess: fetchPartnerHostedCardApplicationSuccess,
    dataError: fetchPartnerHostedCardApplicationError,
    dataReset: fetchPartnerHostedCardApplicationReset,
});

const getRoot = (state) => state.dataModules.partnerHostedCardApplication;
const initialValue = {};

export const partnerHostedCardApplicationDataModule =
    PartnerHostedCardApplicationDataModule({
        getRoot,
        initialValue,
    });

export const getPartnerHostedApplicationUUID = (state) => {
    const data = partnerHostedCardApplicationDataModule.getData(state);
    const uuid = data.uuid || '';

    return uuid;
};

export const getPartnerHostedStatus = (state) =>
    partnerHostedCardApplicationDataModule.getData(state).status || '';
